import {
  mdiChartBar,
  mdiCashMultiple,
  mdiSourceBranch,
  mdiFileDocument,
  mdiCreditCardOutline,
  mdiPackageVariantClosed,
  mdiAccountBox,
  mdiAccount,
  mdiOfficeBuilding,
  mdiStar,
  mdiViewList,
  mdiGift,
  mdiTrophyVariant,
  mdiBullhorn,
  mdiFormatTitle,
  mdiCardBulletedOutline,
  mdiTicketPercent,
  mdiAtomVariant,
  mdiFinance,
} from '@mdi/js';

import isEmpty from 'lodash/isEmpty';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState(['permissions', 'storePermissions', 'superUser']),
    ...mapGetters(['getPermission']),
    navLinks() {
      //   const { permissions, storePermissions, superUser } = this.$store.state;

      let links = [];
      if ((!isEmpty(this.permissions) && !isEmpty(this.storePermissions)) || this.superUser) {
        links = [
          {
            title: {
              el: '',
              en: '',
              it: '',
            },
            children: [
              {
                icon: mdiChartBar,
                title: {
                  el: 'Αρχική',
                  en: 'Home',
                  it: 'Iniziale',
                },
                to: `/${this.lang}/loyaltyPanel`,
                exact: true,
                hide: this.hideTitle('homepage?.read'),
              },
            ],
          },
          {
            title: {
              el: 'ΟΝΤΟΤΗΤΕΣ',
              en: 'ENTITIES',
              it: 'ENTITA',
            },
            children: [
              {
                icon: mdiSourceBranch,
                title: {
                  el: 'Καταστήματα',
                  en: 'Stores',
                  it: 'Stores',
                },
                to: `/${this.lang}/loyaltyPanel/stores`,
                hide: this.hideTitle('stores.read'),
              },
              {
                icon: mdiPackageVariantClosed,
                title: {
                  el: 'Προϊόντα',
                  en: 'Products',
                  it: 'Proddoti',
                },
                to: `/${this.lang}/loyaltyPanel/products`,
                hide: this.hideTitle('products.read'),
              },
              {
                icon: mdiAccountBox,
                title: {
                  el: 'Πελάτες',
                  en: 'Customers',
                  it: 'Clienti',
                },
                to: `/${this.lang}/loyaltyPanel/customers?page=1`,
                hide: this.hideTitle('customers.read'),
              },
              {
                icon: mdiPackageVariantClosed,
                title: {
                  el: 'Προμηθευτές',
                  en: 'Suppliers',
                  it: 'Fornitori',
                },
                to: `/${this.lang}/loyaltyPanel/supplier-management?page=1`,
                hide: this.hideTitle('gifts.read'),
              },
            ],
          },
          {
            title: {
              el: 'ΣΥΣΤΗΜΑ ΠΙΣΤΟΤΗΤΑΣ',
              en: 'LOYALTY SYSTEM',
              it: 'SISTEMA DI FEDELTÀ',
            },
            children: [
              {
                icon: mdiFormatTitle,
                title: {
                  el: 'Επίπεδα',
                  en: 'Tiers',
                  it: 'Livelli',
                },
                to: `/${this.lang}/loyaltyPanel/point-titles`,
                hide: this.hideTitle('point_packages.read'),
              },
              {
                icon: mdiCreditCardOutline,
                title: {
                  el: 'Πολλαπλά Κουπόνια',
                  en: 'Multiple Coupons',
                  it: 'Coupon multipli',
                },
                to: `/${this.lang}/loyaltyPanel/multiple-coupons?page=1`,
                hide: this.hideTitle('coupons.multiple.read'),
              },
              // {
              //     icon: mdiTicketPercent,
              //     title: {
              //         el: "Κουπόνια Καταστημάτων",
              //         en: "Store Coupons",
              //         it: "Coupon del Negozio"
              //     },
              //     to: `/${this.lang}/loyaltyPanel/store-coupons?page=1`,
              // },
              {
                icon: mdiCardBulletedOutline,
                title: {
                  el: 'Κάρτες Πιστότητας',
                  en: 'Loyalty Cards',
                  it: 'Carte fedeltà',
                },
                to: `/${this.lang}/loyaltyPanel/loyalty-cards`,
                hide: this.permissions.loyalty_cards && this.hideTitle('loyalty_cards.read'),
              },
              {
                icon: mdiTrophyVariant,
                title: {
                  el: 'Κατάλογος',
                  en: 'Catalog',
                  it: 'Catalogo',
                },
                to: `/${this.lang}/loyaltyPanel/catalog`,
                hide: this.hideTitle('gifts.read'),
              },
              // {
              //     icon: mdiViewList,
              //     title: {
              //         el: "Διαχείριση Κατηγοριών",
              //         en: "Catalog Categories",
              //         it: "Categorie del catalogo"
              //     },
              //     to: `/${this.lang}/loyaltyPanel/catalog-categories?page=1`,
              //     hide: superUser || storePermissions.gift_categories?.read && permissions.gift_categories && permissions.gift_categories.read ? false : true
              // },
              {
                icon: mdiGift,
                title: {
                  el: 'Εξαργυρώσεις',
                  en: 'Redemptions',
                  it: 'Riscatti',
                },
                to: `/${this.lang}/loyaltyPanel/redemptions`,
                hide: this.hideTitle('gift_categories.read'),
              },
              {
                icon: mdiCreditCardOutline,
                title: {
                  el: 'Συνεργάτες',
                  en: 'Collaborators',
                  it: 'Collaboratori',
                },
                to: `/${this.lang}/loyaltyPanel/collaborators?page=1`,
                hide: this.hideTitle('synergies?.read'),
              },
              {
                icon: mdiBullhorn,
                title: {
                  el: 'Καμπάνιες',
                  en: 'Campaigns',
                  it: 'Campagne',
                },
                to: `/${this.lang}/loyaltyPanel/campaigns/view-campaigns?page=1`,
                hide: this.hideTitle('campaigns.read'),
              },
              {
                icon: mdiAtomVariant,
                title: {
                  el: 'Προγράμματα Πιστότητας',
                  en: 'Loyalty Programs',
                  it: 'Programmi Φedeltà',
                },
                to: `/${this.lang}/loyaltyPanel/loyalty-programs?page=1`,
                hide: this.hideTitle('loyalty.read'),
              },
            ],
          },
          {
            title: {
              el: 'ΔΙΑΧΕΙΡΙΣΗ',
              en: 'MANAGEMENT',
              it: 'GESTIONE',
            },
            children: [
              {
                icon: mdiOfficeBuilding,
                title: {
                  el: 'Προφίλ',
                  en: 'Profile',
                  it: 'Profili',
                },
                to: `/${this.lang}/loyaltyPanel/business-profile`,
                hide: this.hideTitle('profile.read'),
              },
              {
                icon: mdiFinance,
                title: {
                  el: 'Στατιστικά',
                  en: 'Statistics',
                  it: 'Statistiche',
                },
                to: `/${this.lang}/loyaltyPanel/business-statistics?page=1`,
                hide: this.hideTitle('statistics.read'),
              },
              {
                icon: mdiAccount,
                title: {
                  el: 'Χρήστες',
                  en: 'Users',
                  it: 'Utenti',
                },
                to: `/${this.lang}/loyaltyPanel/user-rights?page=1`,
                hide: this.hideTitle('users.read'),
              },
              {
                icon: mdiCashMultiple,
                title: {
                  el: 'Οφειλές',
                  en: 'Debts',
                  it: 'Debiti',
                },
                to: `/${this.lang}/loyaltyPanel/branch-debt`,
                hide: this.hideTitle('stores.debts.read'),
              },

              {
                icon: mdiFileDocument,
                title: {
                  el: 'Συνδρομές',
                  en: 'Subscriptions',
                  it: 'Abbonamenti',
                },
                to: `/${this.lang}/loyaltyPanel/subscriptions`,
                hide: this.hideTitle('subscriptions.read'),
              },
            ],
          },
        ];
      }
      return links;
    },
  },
  methods: {
    ...mapActions(['getUser']),
    hideTitle(permission) {
      return !this.getPermission(permission);
    },
  },
  watch: {
    permissions: {
      handler(val) {
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },

    storePermissions: {
      handler(val) {
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },

  async created() {
    await this.getUser();
  },
};
